import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { useDialog } from "primevue/usedialog";
import { computed, ref } from "vue";

import EntityEditor from "@/components/entities/EntityEditor.vue";
import type { BusinessEntity } from "@/stores/business-entities-store";
import { useCurrentEntityManager } from "@/stores/entity-store";

import { useHotKeys } from "./hotkeys";

export const useEditEntityDialog = () => {
    const { domain } = useCurrentEntityManager();
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));

    const registerHotKey = () => {
        const { addHotKey } = useHotKeys();

        addHotKey(
            "n o",
            (e) => {
                if (!isVisible.value && domain.value?.identity) {
                    e.preventDefault();
                    open();
                }
            },
            "Open new domain object dialog.",
            "Global"
        );
    };

    const open = (entity?: BusinessEntity) => {
        dialogRef.value = dialog.open(EntityEditor, {
            props: {
                header: entity ? "Edit domain object" : "New domain object",
                style: {
                    maxWidth: "600px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
            data: entity,
        });
    };

    return {
        open,
        isVisible,
        registerHotKey,
    };
};
